<template>
  <!-- 储能电池充放电记录 -->
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div">
      <div class="list-header-title-div">储能充放电记录</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">ZD-BOX编号</div>
            <div class="query-inputs-div flex-1">
              <el-input size="small" v-model="queryInfo.stationName" placeholder="请输入ZD-BOX编号"
                        clearable @keyup.enter.native="getListData(pagination, true)"></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">相关站点</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" v-model="queryInfo.isHostOperate" size="small" clearable>
                <el-option label="自运营" value="02"></el-option>
                <el-option label="代运营" value="01"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充放类型</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.processingStatus" clearable>
                <el-option label="电网充电" value="01"></el-option>
                <el-option label="储能放电" value="02"></el-option>
                <el-option label="V2G充电" value="03"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">开始时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                  class="full-width"
                  v-model="queryInfo.searchStartTime"
                  style="width:340px;"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择开始时间"
              />
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">结束时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                  class="full-width"
                  v-model="queryInfo.searchEndTime"
                  style="width:340px;"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择开始时间"
              />
            </div>
          </div>
        </template>
        <template slot="actions">
          <div class="">
            <button class="common-bg-button" @click="getListData(pagination, false)">搜 索</button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
                  :tableConfig="pageConfig.tableConfig" />
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data(){
    return{
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      tableData: [], // 列表数据
      queryInfo: {
        pageNum: 0,
        pageSize: 10,
      },
      // 列操作按钮
      operates: {
        width: 200,
        fixed: "right",
        list: [],
      },
    }
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
  methods: {
    // 数据初始化
    getListData(pagination, reload = false){
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      // 表格数据
      _.$H.post(_, _.$A.order.getDtoList, _.queryInfo).then(res  => {
        _.$U.hideLoading(_);
        _.tableData = res.data.data || [];
      })
      // 页码数据
      _.$H.post(_, _.$A.order.getDtoPageInfo, _.queryInfo).then((res) => {
        _.pagination.total = res.data.data.totalElements || 0;
      });
    },
    // 时间选择
    handleChargeDateChange(val){
      let _ = this;
      if(val && val.length !== 0){
        _.queryInfo.beginTime = val[0];
        _.queryInfo.endTime = val[1];
      }else {
        _.queryInfo.beginTime = '';
        _.queryInfo.endTime = '';
      }
    },
    // 重置
    reset(){
      let _ = this;
      _.queryInfo = {
        occupyStatus: 'Y',
        pileType: '02',
        pageNum: 0,
        pageSize: 10,
        processingStatus: '',
        stationName:'',
        isHostOperate:'',
        custPhone:'',
        pileCode:''
      };
      _.getListData(_.pagination, true);
    },
  },
}
</script>

<style lang="less" scoped></style>

